import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { MatDialogRef } from '@angular/material';
import { isUndefined } from "util";
import { FileUtil }  from './file.util';
import { Constants } from './test.constants';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var amplitude:any;


@Component({
  selector: 'app-new-surveyer-dialog',
  templateUrl: './new-surveyer-dialog.component.html',
  styleUrls: ['./new-surveyer-dialog.component.css']
})

// @ViewChild('fileImportInput')
// fileImportInput: any;
export class NewSurveyerDialogComponent implements OnInit {

  phone: string[];
  password: string;
  phoneEmpty: string[];
  passwordEmpty: string;
  failMsg: string[];
  msg: string[];
  addUser: boolean;
  userAdded: boolean[];
  sendInvite: boolean[];
  add: boolean[];
  teamList: any[];
  selectedTeam: string[];
  enable_team_dropdown: boolean[];
  surveyors: any;
  status: string[];
  csvRecords:any[];
  csvResult:string;
  selectedTab :"addSurveyor"|"assignTeam"="addSurveyor";

  surveyorList:{name:string,mobileNo:string,status:string,teamName:string, teamId:string}[]=[];
  selectedTeamForSurveyor;

  constructor(private restApiService: RestApiService, 
    public newSurveyerDialogRef: MatDialogRef<NewSurveyerDialogComponent>,
    private _fileUtil: FileUtil,private toastyService:ToastyService, 
    private toastyConfig: ToastyConfig) { }
  ngOnInit() {
    this.addUser = true;
    this.phone = ["", "", "", ""];
    this.surveyors = ["Surveyor 1"];
    this.failMsg = ["", "", "", ""];
    this.msg = ['', '','', ''];
    this.status = ["ADD"];
    this.userAdded = [false, false, false, false];
    this.sendInvite = [false, false, false, false];
    this.add = [true, true, true, true];
    this.enable_team_dropdown = [false];
    this.phoneEmpty= [""];
    this.selectedTeam = ['Assign team'];
    this.restApiService.getGroupListWithDetailsForAdminService(null).subscribe(
      result => {
        this.teamList = result.groups;
      });
      this.csvRecords = [];
      this.csvResult=' ';
  }

  teamSelected(addTeam, index) {
    this.selectedTeam[index] = addTeam.teamName;
    // appending +91 for username with country code.
    const username = "+91"+this.phone[index]
    this.restApiService.setTeamForSurveyor(username,addTeam.teamName).subscribe(
      result => {
        // console.log(result);
        if(result.success== true)
        {
          this.msg[index]='Team successfully added';
        }
      });

  }

  addTeamnamesInBulk(){
    if(!this.surveyorList || this.surveyorList.length ==0){
      return;
    }
    let phoneNos = [];
    let teamIds = [];
    this.surveyorList.forEach(data=>{
      phoneNos.push(data.mobileNo);
      teamIds.push(data.teamId);
    })
    this.restApiService.setMultipleTeamForMulipleSurveyor(phoneNos,teamIds).subscribe(response=>{
      if(response && response.success){
        this.newSurveyerDialogRef.close({ success: true });
      }
    })
  }

  assignSurveyor(row,index){
    this.surveyorList[index].teamName = row.teamName;
    this.surveyorList[index].teamId = row.id;
  }
  showNext = false;
  onNext(){
    if(this.teamList && this.teamList.length>0){
      this.showNext= true;
      let team = this.teamList.findIndex(data=>data.teamName == this.selectedTeamForSurveyor);
      if(team != -1){
        this.surveyorList.forEach(data=>{
          data.teamId = this.teamList[team].id;
          data.teamName = this.teamList[team].teamName;
        })
      }
    }
    return;
  }

  teamSelectedForSurveyor(row){
    this.selectedTeamForSurveyor = row.teamName;
    // this.surveyorList.forEach(data=>{
    //   data.teamId = row.id;
    //   data.teamName = row.teamName;
    // })
  }
  choosefile()
  {
    amplitude.getInstance().logEvent('choosefileclickedafterclickingonAddsurveyor');
  }
  invalidPhoneNo(index){
    if (this.phone[index] == null || isUndefined(this.phone[index]) || this.phone[index] == ""||isNaN(Number(this.phone[index]))|| this.phone[index].length<10) {
      return true;
    }
    return false;
  }
  invalidAddOneMore(){
    const lastItem = this.surveyors.length - 1;
    if(this.status[lastItem] && 
      (this.status[lastItem]=='ALREADY ADDED' || this.status[lastItem]=='INVITED') ){
        return false;
      }
    return true;
  }
  onUserAdd(phone, index) {
    amplitude.getInstance().logEvent('AddButtonisclclickedafterclickingonAddsurveyor');
    this.failMsg[index] = "";
    if (this.phone[index] == null || isUndefined(this.phone[index]) || this.phone[index] == ""||isNaN(Number(this.phone[index]))|| this.phone[index].length<9) {
      this.phoneEmpty[index] = "on-error";
      // this.passwordEmpty = "";
      return;
    }
    // else if (this.password == null || isUndefined(this.password) || this.password == "") {
    //   this.phoneEmpty = "";
    //   // this.passwordEmpty = "on-error";
    //   return;
    // }
    else {
      this.phoneEmpty[index] = "";
      this.passwordEmpty = "";
      const phoneNo = "+91"+this.phone[index];
      this.restApiService.createNewSurveyer(phoneNo).subscribe(
        result => {
          if (result.success != false) {
            if (result.status == "ADDED") {
              this.status[index] = result.status;
              this.userAdded[index] = true;
              this.add[index] = false;
              this.enable_team_dropdown[index] = true;
              this.failMsg[index] = "User Successfully added";
            }
            if (result.status == "ALREADY ADDED") {
              this.status[index] = result.status;
              this.failMsg[index] = "User Already added";
              this.enable_team_dropdown[index] = true;
            }
            if (result.status == "INVITED") {
              this.status[index] = result.status;
              this.sendInvite[index] = true;
              this.add[index] = false;
              this.failMsg[index] = "The user hasn't signed up on mobile app.Invite user to sign up!";
              this.enable_team_dropdown[index] = true;
            }
            // this.failMsg[index] ="Successfully Added";
            // this.newSurveyerDialogRef.close(result);
          }
          else {

            this.failMsg[index] = result.msg.message;
            if (result.msg.code == 'UsernameExistsException') {
              this.addUser = false;
              this.failMsg[index] = this.failMsg[index].replace("phone_number", "Phone Number");
              this.failMsg[index] += 'Please Send Invitation'
            }
          }

        });
    }
  }

  onDiscard() {
    this.newSurveyerDialogRef.close({ success: false });
  }

  discardYes(){
    this.newSurveyerDialogRef.close({ success: true });
  }

  sendinvite(user,index) {
    user= "+91"+user;
    // this.status[index]="RESEND INVITE";
    this.restApiService.inviteSurveyerService(user).subscribe(
      result => {
        if(result.status=='invited')
        {
        this.restApiService.updateinvitesent(user).subscribe( result => {
          this.msg[index]='Invite successfully sent.';
          this.failMsg[index]="";
          this.status[index]="SENT";
        });
        var toastOptions:ToastOptions = {
          title: "Invitation Sent",
          msg: "Invitation was successfully sent to the surveyor",
          showClose: true,
          timeout: 3000,
          theme: 'bootstrap'
        };
        this.toastyService.success(toastOptions);
        }
      });
  }
  // onUserInvite() {
  //   this.restApiService.inviteSurveyerService(this.phone).subscribe(
  //     result => {
  //       if (result.success != false) {
  //         // console.log(result[0].qID);
  //         this.newSurveyerDialogRef.close(result);
  //       }
  //       else {
  //         if (result.code == '23505') {
  //           // this.failMsg = 'User is Already Added in Your account';
  //         }
  //         else {
  //           this.failMsg = result.msg.message;
  //         }
  //         // this.failMsg = ;
  //         // if(result.msg.code=='UsernameExistsException')
  //         // {
  //         //   this.addUser = false;
  //         //   this.failMsg+= 'Please Send Invitation'
  //         // }
  //       }
  //     });
  // }
  fileChangeListener($event): void {
    this.filename = null;
    var text = [];
    var files = $event.srcElement.files;

    if(Constants.validateHeaderAndRecordLengthFlag){
      if(!this._fileUtil.isCSVFile(files[0])){
        alert("Please import valid .csv file.");
        this.fileReset();
      }
    }

    var input = $event.target;
    var reader = new FileReader();
    reader.readAsText(input.files[0]);

    reader.onload = (data) => {
      let csvData = reader.result;
      let csvRecordsArray = csvData.split(/\r\n|\n/);

      var headerLength = -1;
      if(Constants.isHeaderPresentFlag){
        let headersRow = this._fileUtil.getHeaderArray(csvRecordsArray, Constants.tokenDelimeter);
        headerLength = headersRow.length;
      }

      this.csvRecords = this._fileUtil.getDataRecordsArrayFromCSVFile(csvRecordsArray,
          headerLength, Constants.validateHeaderAndRecordLengthFlag, Constants.tokenDelimeter);

      if(this.csvRecords == null){
        //If control reached here it means csv file contains error, reset file.
        this.fileReset();
      }
      if($event && $event.target && $event.target.files && $event.target.files.length>0){
        this.filename = $event.target.files[0].name;
      }
    }

    reader.onerror = function () {
      alert('Unable to read ' + input.files[0]);
    };
  };

  filename:string;

  uploadCSV(){
    if(this.csvRecords.length!=0)
    {
    this.restApiService.uploadSurveyorCSV(JSON.stringify(this.csvRecords)).subscribe(
      result => {
      //  console.log(result);
       if(result.success && result.data){
        this.surveyorList = [];
        this.csvResult='File successfully uploaded';
        this.selectedTab = 'assignTeam';
        let index = 1;
        result.data.forEach(data=>{
          let status = data.status == 'ALREADY ADDED'|| data.status == 'ADDED'?'Added':'Invited';
          const surveyorSample = "Surveyor "+index+":";
          this.surveyorList.push({name:surveyorSample,mobileNo:data.phone,status:status,
            teamName:null,teamId :null});
          index = index +1;
        })
       }
      });
    }
    else{
      this.csvResult='File not selected';
    }
  }
  fileReset(){
    // this.fileImportInput.nativeElement.value = "";
    this.csvRecords = [];
  }

  isNumber(evt) {
    // accept only numbers
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }

  addSurveyorSample(){
    let index = 1;
    if(this.surveyors){
      index =this.surveyors.length + 1;
    }
    const surveyorSample = "Surveyor "+index+":";
    this.surveyors.push(surveyorSample);
    this.phoneEmpty.push("");
    this.status.push("ADD");
    this.selectedTeam.push("Assign team");
    this.enable_team_dropdown.push(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/newSurveyerDialog/new-surveyer-dialog.component.ts